module.exports = __webpack_public_path__ + "img/menuIcon15.e92146c1.png";